var _toConsumableArray = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var HistoryEvent = require('./HistoryEvent');

var STORAGE_KEY = 'burner-history';

var History =
/*#__PURE__*/
function () {
  "use strict";

  function History() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$storeHistory = _ref.storeHistory,
        storeHistory = _ref$storeHistory === void 0 ? true : _ref$storeHistory,
        _ref$assets = _ref.assets,
        assets = _ref$assets === void 0 ? [] : _ref$assets;

    _classCallCheck(this, History);

    this.events = [];
    this.assets = assets;
    this.eventListeners = [];
    this.storeHistory = storeHistory;

    if (storeHistory) {
      this.readStoredEvents();
    }
  }

  _createClass(History, [{
    key: "onEvent",
    value: function onEvent(callback) {
      this.eventListeners.push(callback);
    }
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      this.eventListeners.splice(this.eventListeners.indexOf(callback), 1);
    }
  }, {
    key: "addEvent",
    value: function addEvent(event) {
      this.events.push(event);
      this.eventListeners.forEach(function (callback) {
        return callback(event);
      });
      this.storeEvents();
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var events = this.events;

      if (options.asset) {
        events = events.filter(function (event) {
          return event.asset = options.asset;
        });
      }

      events = events.sort(function (e1, e2) {
        return e2.timestamp - e1.timestamp;
      });
      return events;
    }
  }, {
    key: "storeEvents",
    value: function storeEvents() {
      if (this.storeHistory) {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(this.events));
      }
    }
  }, {
    key: "readStoredEvents",
    value: function readStoredEvents() {
      var _this = this;

      if (window.localStorage.getItem(STORAGE_KEY)) {
        var storedEventObjs = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        this.events = [].concat(_toConsumableArray(this.events), _toConsumableArray(storedEventObjs.map(function (event) {
          return new HistoryEvent(event, _this.assets);
        })));
      }
    }
  }]);

  return History;
}();

module.exports = History;